export enum PageTab {
  Templates = 'templates',
  Conflicts = 'conflicts',
  Policies = 'policies',
  Archived = 'archived'
}
